// @ts-nocheck
import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { ScoreChip } from 'components/shared/ScoreChip/ScoreChip'
import { Table } from 'components/shared/Table/Table'

import { getFactorScoreTreshholds } from 'utils/score'
import { percentScore } from 'utils/stringFormat'

export const ScoreCell = ({
  className,
  maxWidth,
  score,
  hasIncreasedHeight,
}) => (
  <Table.Cell type="body" {...{ className, maxWidth, hasIncreasedHeight }}>
    <Box align="center" justify="center" tagName="span">
      <ScoreChip
        size="small"
        score={percentScore(score)}
        theme={getFactorScoreTreshholds(score)}
      />
    </Box>
  </Table.Cell>
)
